<template>
  <main class="mod-home">
    <section ref="swiperRef" class="swiper-container mod-home-swiper" aria-label="首页轮播图"
      @mouseenter="pauseSwiper(swiperInstance)" @mouseleave="resumeSwiper(swiperInstance)">
      <div class="swiper-wrapper">
        <article v-for="slide in bannerList" :key="slide.areaDataID" class="swiper-slide mod-home-slide">
          <img class="slide-image" :src="slide.image" draggable="false" />
          <div class="slide-content">
            <h2 class="slide-title">{{ slide.title }}</h2>
            <p class="slide-description">{{ slide.subTitle }}</p>
            <!-- pc 版本 -->
            <section class="version-info-pc" v-if="!isOverseas || locale === 'vi'">
              <div>{{ t('version') }}：V{{ productInfo.versionCode }}</div>
              <div>{{ t('updateTime') }}：{{ productInfo.onlineTime }}</div>
            </section>
          </div>
        </article>
      </div>
      <div class="home-swiper-pagination"></div>
      <img v-if="!isOverseas" class="home-tips" src="@/assets/images/home/8+.png" @click="showTips = true">
      <ClientOnly>
        <div class="download-container">
          <img class="download-icon" v-if="environment.isIos || isOverseas" src="@/assets/images/apple-down.png"
            @click="downloadApp(isOverseas ? 'appleOverseas' : 'apple')" />
          <img class="download-icon" v-if="(environment.isAndroid && !isOverseas) || locale === 'vi'"
            src="@/assets/images/and-down.png" @click="downloadApp('android')" />
          <img v-if="!isOverseas" class="download-icon" src="@/assets/images/tap-down.png"
            @click="downloadApp('tap')" />
          <img v-else-if="locale !== 'vi'" class="download-icon" src="@/assets/images/google-down.png"
            @click="downloadApp('google')" />
          <div class="version-info" v-if="!isOverseas || locale === 'vi'">
            <div>{{ t('version') }}：V{{ productInfo.versionCode }}</div>
            <div>{{ t('updateTime') }}：{{ productInfo.onlineTime }}</div>
          </div>
          <div class="down2" v-if="locale === 'vi'">
            <span @click="downloadApp('android2')">{{ t('clickHere.text1') }}</span>
            {{ t('clickHere.text2') }}
          </div>
        </div>
      </ClientOnly>

    </section>
    <!-- 问卷 -->
    <div class="questionnaire" v-if="surveyInfo.surveyLink" @click="openLink(surveyInfo.surveyLink)">
      {{ t('questionnaire') }}
    </div>

    <!-- pc下载 -->
    <div class="download-container-pc">
      <section class="qrcode" v-if="downloadUrl">
        <Qrcode :value="downloadUrl" />
      </section>
      <div class="sacn-code">{{ t('scanCode') }}</div>
      <section class="download">
        <img v-if="!isOverseas" src="@/assets/images/tap-down.png" @click="downloadApp('tap')">
        <img v-if="isOverseas" src="@/assets/images/apple-down.png" @click="downloadApp('appleOverseas')">
        <img v-if="!isOverseas" src="@/assets/images/apple-down.png" @click="downloadApp('apple')">
        <img v-if="isOverseas && locale !== 'vi'" src="@/assets/images/google-down.png" @click="downloadApp('google')">
        <img v-if="!isOverseas || locale === 'vi'" src="@/assets/images/and-down.png" @click="downloadApp('android')">
      </section>
      <section class="media">
        <img v-if="!isOverseas" src="@/assets/images/home/dy.png" @click="jumpMedia('dy')">
        <img v-if="isOverseas" src="@/assets/images/home/dy.png" @click="jumpMedia('tiktok')">
        <img v-if="isOverseas" src="@/assets/images/home/ytb.png" @click="jumpMedia('youtube')">
        <img v-if="!isOverseas" src="@/assets/images/home/xhs.png" @click="jumpMedia('xhs')">
        <img v-if="!isOverseas" src="@/assets/images/home/ks.png" @click="jumpMedia('ks')">
      </section>
    </div>
    <!-- 新闻公告 -->
    <section class="announcement">
      <div class="head-banner">
        <div class="head-img"><img :src="newsInfo.image"></div>
        <section class="head-content">
          <h3 class="head-title">{{ newsInfo.title }}</h3>
          <p class="head-description">{{ newsInfo.subTitle }}</p>
        </section>
      </div>
      <article class="announcement-list">
        <div class="announcement-title">
          <div class="title">{{ t('news') }}</div>
          <div class="more"
            @click="openLink(isOverseas ? 'https://www.tiktok.com/@gameworld.lifestory' : 'https://www.taptap.cn/app/856059/topic?os=android&type=official')">
            {{
              t('readNews') }}
            <img class="arrow-icon" src="@/assets/images/home/arrow-right.png">
          </div>
        </div>
        <div class="announcement-item" v-for="item in newsList" @click="announcementJump(item.linkUrl)">
          <div class="announcement-text">{{ item.title }}</div>
          <div class="announcement-date">{{ item.newsTime }}</div>
          <div class="item-icon"></div>
        </div>
      </article>
    </section>
    <!-- 产品特色 -->
    <section class="product">
      <div class="product-title">{{ t('features') }}</div>
      <section ref="swiperProductRef" class="swiper-container product-swiper"
        @mouseenter="pauseSwiper(swiperProductInstance)" @mouseleave="resumeSwiper(swiperProductInstance)">
        <div class="swiper-wrapper">
          <article v-for="(slide, index) in productList" :key="slide.areaDataID"
            class="swiper-slide product-swiper-slide">
            <div class="slide-image"> <img :src="slide.image" draggable="false" /></div>
            <div class="slide-content">
              <h2 class="slide-title">{{ slide.title }}</h2>
              <p class="slide-description">{{ slide.subTitle }}</p>
            </div>
          </article>
        </div>
        <div class="product-swiper-pagination"></div>
      </section>
    </section>
    <!-- 适龄提示 -->
    <section v-show="showTips" class="tips">
      <div class="tips-title">适龄提示</div>
      <div class="tips-content" v-html="tipsContent">
      </div>
      <div class="tips-close" @click="showTips = false"></div>
    </section>
    <!-- 遮罩 -->
    <div v-show="showTips" class="mask" />
  </main>
</template>

<script setup lang="ts">
import Swiper from "swiper";
import { getPageInfo } from "@/api";
import type { BannerItem, ProductInfo, NewsItem, NewsInfo, SurveyInfo } from "../../src/types/apiData";
const { isOverseas, downloadConfig, environment, mediaConfig, langText, networktype } = useAppState()
definePageMeta({
  pageType: 'home',
});
const meta = isOverseas.value ? {
  title: 'Kalliu World (Game World)',
  description: 'Kalliu World (Game World) Official Website Create your own world freely. Explore the latest product features, game downloads, version updates, news, announcements, and more.',
  ogTitle: 'Kalliu World (Game World) Start your journey of limitless creativity.',
  ogDescription: 'Kalliu World (Game World) Download the game and explore the latest version updates and official news.',
} : {
  title: '跃次元 - 可露优世界',
  description: '可露优世界 （创意世界）官网，自由创造属于你的世界，获取产品特色、下载与版本动态、新闻公告等最新资讯',
  ogTitle: '可露优世界 （创意世界），开启自由创造之旅',
  ogDescription: '可露优世界 （创意世界），下载游戏，查看版本更新与官方资讯',
}
useSeoMeta(meta)
const { locale, t } = useI18n();
const downloadUrl = ref('')
const { data: pageData } = await useAsyncData('pageInfo', () =>
  getPageInfo({ PlatForm: 0 })
)
const bannerList = ref<BannerItem[]>([])
const header = pageData.value?.areaData?.find(i => i.moduleCode === 'Header')
bannerList.value = header?.data.sort((a, b) => a.sortIndex - b.sortIndex)?.map(d => ({
  image: d.fieldData.picUrl,
  title: d.fieldData.subTitle,
  subTitle: d.fieldData.subTitleEx,
  areaDataID: d.areaDataID
})) || []
const productList = computed<BannerItem[]>(() => {
  const scene = pageData.value?.areaData?.find(i => i.moduleCode === "Scene")
  return scene?.data[0]?.fieldData.productPics.map((d, idx) => ({
    image: d.picUrl,
    title: d.title,
    subTitle: d.subTitle,
    areaDataID: idx
  }))
})
const surveyInfo = computed<SurveyInfo>(() => {
  const scene = pageData.value?.areaData?.find(i => i.moduleCode === "Scene")
  return scene?.data[0]?.fieldData.surveyInfo || {
    surveyLink: ''
  }
})
const openLink = (link: string) => {
  window.open(link)
}
const newsList = computed<NewsItem[]>(() => {
  const promote = pageData.value?.areaData?.find(i => i.moduleCode === 'Promote')
  return promote?.data
    ?.sort((a, b) => {
      // 第一条件：isTop置顶
      const topDiff = Number(b.isTop) - Number(a.isTop);
      if (topDiff !== 0) {
        return topDiff;
      }
      // isTop相同的时候，再使用 sortIndex
      return a.sortIndex - b.sortIndex;
    })
    ?.map(d => {
      return {
        ...d.fieldData,
        newsTime: d.fieldData.newsTime.split(' ')[0]
      }
    }) || []
})
const newsInfo = computed<NewsInfo>(() => {
  const promote = pageData.value?.areaData?.find(i => i.moduleCode === 'Promote')
  return {
    image: promote?.style.fieldData.picUrl as string,
    title: promote?.style.fieldData.subTitle as string,
    subTitle: promote?.style.fieldData.subTitleEx as string
  }
})

const productInfo = computed<ProductInfo>(() => {
  const product = pageData.value?.areaData?.find(i => i.moduleCode === 'productInfo')
  const field = product?.data?.[0]?.fieldData
  if (!field) {
    return { onlineTime: '', otherPackageUrl: '', packageUrl: '', versionCode: '' }
  }
  return {
    ...field,
    onlineTime: field.onlineTime?.split(' ')[0] || ''
  }
})

const tipsContent = computed(() => {
  const scene = pageData.value?.areaData?.find(i => i.moduleCode === 'Scene')
  const tip = scene?.data?.[0]?.fieldData?.ageTip
  return tip ? tip.replaceAll('\n', '<br/>') : ''
})
const { deviceType, updateDevice } = useDevice()
onMounted(async () => {
  aiolosRecordEvent('page_view', {
    page: '首页',
    language: langText
  })
  const localePath = useLocalePath();
  downloadUrl.value = location.origin + localePath({ name: 'download' }) + `?source=${encodeURIComponent('侧边栏-扫码')}`
  updateDevice()
  if (deviceType.value === 'mobile') {
    const pageData = await getPageInfo({ PlatForm: 71 })
    const header = pageData?.areaData?.find(i => i.moduleCode === 'Header')
    bannerList.value = header?.data.sort((a, b) => a.sortIndex - b.sortIndex)?.map(d => ({
      image: d.fieldData.mobilePic ?? d.fieldData.picUrl,
      title: d.fieldData.subTitle,
      subTitle: d.fieldData.subTitleEx,
      areaDataID: d.areaDataID
    })) || []
  }
  nextTick(() => {
    initSwiper()
  })
});
//新闻跳转
const announcementJump = (link: string) => {
  window.open(link)
}
const downloadApp = async (type: string) => {
  const downloadMap = {
    'android': productInfo.value.otherPackageUrl || productInfo.value.packageUrl,
    'android2': productInfo.value.otherPackageUrl,
    'apple': downloadConfig.gameWorldIos,
    'appleOverseas': downloadConfig.gameWorldOverseasIos,
    'tap': downloadConfig.tapUrl,
    'google': downloadConfig.gameWorldGoogle
  }
  try {
    if (['android', 'android2'].includes(type)) {
      // const fileInfo = await downloadFileWithInfo(downloadMap[type], {
      //   onProgress: (loaded: number, total: number) => {
      //   }
      // })
      aiolosRecordEvent(isOverseas.value ? 'overseas_download' : 'domestic_download', {
        place: type == 'android' ? '侧边栏-apk' : '侧边栏-备用apk',
        device: environment.isPc ? 'pc' : '手机',
        networktype: networktype,
        language: langText,
        result: '下载成功'
      })
    }
    window.open(downloadMap[type])
  } catch {
    window.open(downloadMap[type])
    aiolosRecordEvent(isOverseas.value ? 'overseas_download' : 'domestic_download', {
      place: type == 'android' ? '侧边栏-apk' : '侧边栏-备用apk',
      device: environment.isPc ? 'pc' : '手机',
      networktype: networktype,
      language: langText,
      Time: '未知',
      package: '未知',
      result: '下载成功'
    })
  }
}
const jumpMedia = (type: string) => {
  const ketToText = {
    xhs: '小红书',
    ks: '快手',
    dy: '抖音',
    tiktok: 'Tiktok',
    youtube: 'Youtube'
  }
  aiolosRecordEvent(isOverseas.value ? 'overseas_social' : 'domestic_social', {
    place: `侧边栏${ketToText[type]}`,
    language: langText
  })
  window.open(mediaConfig[type])
}
const swiperRef = ref<HTMLElement | null>(null);
const swiperProductRef = ref<HTMLElement | null>(null);
const initSwiper = () => {
  if (!swiperRef.value) {
    return;
  }
  if (!swiperProductRef.value) {
    return;
  }
  window.addEventListener('resize', handleResize);
  swiperInstance = new Swiper(swiperRef.value, {
    autoplay: bannerList.value.length > 1 ? { delay: 3000, disableOnInteraction: false } : false,
    loop: bannerList.value.length > 1,
    pagination: {
      el: '.home-swiper-pagination',
      clickable: true,
    },
  });
  swiperProductInstance = new Swiper(swiperProductRef.value, {
    autoplay: productList.value.length > 1 ? { delay: 3000, disableOnInteraction: false } : false,
    loop: productList.value.length > 1,
    pagination: {
      el: '.product-swiper-pagination',
      clickable: true,
    },
    spaceBetween: 20,
    slidesPerView: 1,
    breakpoints: {
      768: {
        autoplay: productList.value.length > 1 ? { delay: 0, disableOnInteraction: false } : false,
        centeredSlides: true,
        slidesPerView: 2.3,
        spaceBetween: 70,
        freeMode: true,
        // allowTouchMove: false,
        speed: 4000,
      }
    }
  });
}
const showTips = ref(false)
let swiperInstance: any = null;
let swiperProductInstance: any = null;

const pauseSwiper = (instance: any) => {
  instance?.autoplay?.stop();
};

const resumeSwiper = (instance: any) => {
  instance?.autoplay?.start();
};


const handleResize = () => {
  if (swiperInstance) {
    swiperInstance.update();
  }
  if (swiperProductInstance) {
    swiperProductInstance.update();
  }
};

onBeforeUnmount(() => {
  swiperInstance?.destroy(true, true);
  swiperProductInstance?.destroy(true, true);
  swiperInstance = null;
  swiperProductInstance = null
});
</script>

<style lang="less" scoped>
.mod-home {
  background-image: url('../assets/images/pc-bg.png');
  background-size: contain;
  background-position-y: 1910px;

  .version-info-pc {
    display: none;
  }

  @keyframes pulse {

    0%,
    100% {
      transform: scale(1);
    }

    50% {
      transform: scale(1.1);
    }
  }

  .questionnaire {
    position: fixed;
    top: 274px;
    right: 29px;
    background-image: url('../assets/images/home/questionnaire.png');
    width: 240px;
    height: 95px;
    background-size: cover;
    z-index: 2;
    text-align: center;
    font-weight: bold;
    font-size: 35px;
    color: #661953;
    line-height: 85px;
    text-shadow:
      -1px -1px 0 #fff,
      1px -1px 0 #fff,
      -1px 1px 0 #fff,
      1px 1px 0 #fff;
    cursor: pointer;
    animation: pulse 2.5s ease-in-out infinite;
  }

  .download-container-pc {
    display: none;
  }

  .mod-home-swiper {
    width: 100%;
    height: 1365px;
    position: relative;

    .home-tips {
      position: absolute;
      top: 274px;
      left: 29px;
      width: 173px;
      height: 222px;
      z-index: 10;
      cursor: pointer;
    }

    .download-container {
      width: 100%;
      height: 250px;
      display: flex;
      position: absolute;
      justify-content: space-around;
      bottom: 0;
      z-index: 10;

      .download-icon {
        width: 392px;
        height: 121px;
        object-fit: cover;
      }

      .down2 {
        position: absolute;
        bottom: 32px;
        width: 100%;
        display: flex;
        justify-content: center;
        font-size: 32px;

        span {
          text-decoration-line: underline;
          color: #D777FF;
          cursor: pointer;
          margin-right: 6px;
        }
      }

      .version-info {
        position: absolute;
        bottom: 32px;
        width: 100%;
        display: flex;
        justify-content: center;

        div {
          font-weight: 400;
          font-size: 32px;
          color: #ffffff;
          line-height: 49px;
          margin-right: 29px;
        }
      }
    }

    :deep(.home-swiper-pagination) {
      bottom: 279px;
      left: 50%;
      transform: translateX(-50%);
      position: absolute;
      z-index: 10;
      display: flex;
      justify-content: center;
    }

    :deep(.swiper-pagination-bullet) {
      width: 20px;
      height: 20px;
      background: rgba(255, 255, 255, 1);
      opacity: .5;
      border-radius: 50%;
    }

    :deep(.swiper-pagination-bullet-active) {
      width: 54px;
      height: 20px;
      background: #FFFFFF;
      border-radius: 10px;
      opacity: 1;
    }
  }

  .mod-home-slide {
    width: 100%;
    height: 100%;
    position: relative;

    .slide-image {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
      user-select: none;
    }

    .slide-content {
      width: 1080px;
      height: 510px;
      background: rgba(255, 255, 255, 0);
      backdrop-filter: blur(18px);
      -webkit-backdrop-filter: blur(18px);
      position: absolute;
      bottom: -2px;
      left: 0;
      padding: 40px 75px;
      box-sizing: border-box;

      .slide-title {
        font-weight: 900;
        font-size: 58px;
        color: #FFFFFF;
        line-height: 86px;
        width: 850px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .slide-description {
        font-weight: 500;
        font-size: 43px;
        color: rgba(255, 255, 255, 0.96);
        line-height: 66px;
        width: 850px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }

  }


  .announcement {
    padding: 121px 29px;
    position: relative;

    .head-banner {
      position: relative;
      width: 1022px;
      height: 899px;
      background: rgba(255, 255, 255, 0.5);
      border-radius: 63px;
      border: 6px solid #FFFFFF;
      backdrop-filter: blur(6.5px);
      -webkit-backdrop-filter: blur(6.5px);
      display: none;
      justify-content: center;
      align-items: center;

      img {
        width: 945px;
        height: 818px;
        object-fit: cover;
        border-radius: 40px;
      }
    }

    .head-content {
      width: 945px;
      height: 202px;
      background: linear-gradient(180deg, rgba(23, 23, 23, 0) 0%, rgba(72, 72, 72, 0.8) 99.31%);
      border-radius: 0px 0px 46px 46px;
      position: absolute;
      bottom: 40px;
      padding: 55px 49px;
      box-sizing: border-box;
    }

    .head-title {
      font-weight: bold;
      font-size: 46px;
      color: #FFFFFF;
      line-height: 69px;
    }

    .head-description {
      font-weight: 500;
      font-size: 37px;
      color: rgba(255, 255, 255, 0.8);
      line-height: 58px;
    }

    &-title {
      display: flex;
      justify-content: space-between;
      padding: 0px 49px 17px 46px;

      .title {
        font-weight: bold;
        font-size: 58px;
        color: #1F1F1F;
        line-height: 86px;
      }

      .more {
        font-weight: 900;
        font-size: 37px;
        color: #575757;
        line-height: 58px;
        display: flex;
        align-items: center;
        cursor: pointer;
      }

      .arrow-icon {
        width: 33px;
        height: 33px;
        margin-left: 10px;
        object-fit: contain;
      }
    }

    &-item {
      width: 100%;
      height: 230px;
      background: rgba(0, 0, 0, 0.03);
      border-radius: 75px;
      backdrop-filter: blur(12px);
      -webkit-backdrop-filter: blur(12px);
      padding: 63px 46px;
      box-sizing: border-box;
      margin-top: 43px;
      position: relative;
      cursor: pointer;

      &:hover {
        background: rgba(0, 0, 0, 0.06);
      }

      &:hover .item-icon {
        background-color: #D777FF;
        border: 3px solid #ffffff;
        background-image: url('../assets/images/home/open-icon-active.png');
      }
    }

    &-text {
      width: 749px;
      font-weight: bold;
      font-size: 43px;
      color: #1F1F1F;
      line-height: 66px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &-date {
      font-weight: 500;
      font-size: 37px;
      color: #979797;
      line-height: 58px;
    }

    .item-icon {
      position: absolute;
      right: 46px;
      top: 50%;
      transform: translateY(-50%);
      width: 55px;
      height: 30px;
      cursor: pointer;
      padding: 32px 20px 32px 17px;
      border: 3px solid #979797;
      backdrop-filter: blur(10px);
      -webkit-backdrop-filter: blur(10px);
      border-radius: 50%;
      background-image: url('../assets/images/home/open-icon.png');
      background-size: 55px 30px;
      background-repeat: no-repeat;
      background-position: center;
      background-color: #fff;
    }

  }

  .product {
    padding-bottom: 132px;

    &-title {
      font-weight: bold;
      font-size: 58px;
      color: #1F1F1F;
      line-height: 86px;
      text-align: center;
    }

    .product-swiper {
      margin-top: 46px;
      width: 1022px;
      height: 608px;
      background: rgba(255, 255, 255, 0.5);
      border-radius: 63px;
      border: 6px solid #FFFFFF;
      backdrop-filter: blur(5px);
      -webkit-backdrop-filter: blur(5px);
      padding: 40px;
      box-sizing: border-box;

      :deep(.product-swiper-pagination) {
        bottom: 52px;
        left: 50%;
        transform: translateX(-50%);
        position: absolute;
        z-index: 10;
        display: flex;
        justify-content: center;
      }

      :deep(.swiper-pagination-bullet) {
        width: 12px;
        height: 12px;
        background: rgba(255, 255, 255, 0.5);
        border-radius: 50%;
      }

      :deep(.swiper-pagination-bullet-active) {
        width: 32px;
        height: 12px;
        background: #FFFFFF;
        border-radius: 6px;
      }
    }

    .product-swiper-slide {
      width: 100%;
      height: 100%;
      position: relative;
      transition: transform .333s;


      .slide-image {
        display: block;
        width: 100%;
        height: 100%;
        border-radius: 20px;
        user-select: none;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .slide-content {
        position: absolute;
        bottom: 0;
        width: 935px;
        height: 163px;
        background: linear-gradient(180deg, rgba(23, 23, 23, 0) 0%, rgba(72, 72, 72, 0.8) 99.31%);
        border-radius: 0px 0px 31px 31px;
        padding: 23px 55px;
        box-sizing: border-box;

        .slide-title {
          width: 100%;
          font-weight: bold;
          font-size: 46px;
          color: #FFFFFF;
          line-height: 69px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .slide-description {
          width: 100%;
          font-weight: 500;
          font-size: 37px;
          color: rgba(255, 255, 255, 0.8);
          line-height: 58px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }

  .mask {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 998;
  }

  .tips {
    width: 1025px;
    height: 919px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;

    &::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      background-image: url('../assets/images/home/tips-bg.png');
      z-index: 1;
      background-size: cover;
    }

    &-close {
      position: absolute;
      width: 138px;
      height: 138px;
      background: rgba(255, 255, 255, 0.5);
      border-radius: 70px;
      border: 6px solid #FFFFFF;
      backdrop-filter: blur(10px);
      -webkit-backdrop-filter: blur(10px);
      bottom: -196px;
      left: 50%;
      transform: translateX(-50%);
      background-image: url('../assets/images/home/close-icon.png');
      background-repeat: no-repeat;
      background-size: 50px 50px;
      background-position: 44px 44px;
      transition: transform 0.3s ease;
      cursor: pointer;
    }



    &-title {
      width: 100%;
      height: 110px;
      position: relative;
      font-weight: bold;
      font-size: 52px;
      color: #FFFFFF;
      line-height: 110px;
      z-index: 2;
      text-align: center;
    }

    &-content {
      position: relative;
      width: 919px;
      max-height: 700px;
      overflow-y: auto;
      z-index: 2;
      margin: 50px auto 0;
      font-weight: 400;
      font-size: 37px;
      color: #505050;
      line-height: 60px;
    }
  }
}

@media only screen and (min-width: 768px) {
  .mod-home {
    background-image: url('../assets/images/pc-bg.png');
    background-position-y: 501px;
    background-repeat: no-repeat;
    background-size: cover;

    .questionnaire {
      top: 360px;
      right: 14px;
      background-image: url('../assets/images/home/questionnaire.png');
      width: 105px;
      height: 42px;
      background-size: cover;
      z-index: 2;
      text-align: center;
      font-weight: bold;
      font-size: 12px;
      color: #661953;
      line-height: 40px;
      text-shadow:
        -1px -1px 0 #fff,
        1px -1px 0 #fff,
        -1px 1px 0 #fff,
        1px 1px 0 #fff;
    }

    .mod-home-swiper {
      height: 501px;

      .home-tips {
        width: 47px;
        height: 60px;
        top: 96px;
        left: 24px;
      }

      .download-container {
        display: none;
      }

      :deep(.home-swiper-pagination) {
        bottom: 12px;
      }

      :deep(.swiper-pagination-bullet) {
        width: 6px;
        height: 6px;
      }

      :deep(.swiper-pagination-bullet-active) {
        width: 15px;
        height: 6px;
      }
    }

    .mod-home-slide {
      .slide-content {
        height: 115px;
        padding: 28px 0 22px 96px;

        .slide-title {
          width: 700px;
          font-size: 28px;
          line-height: 34px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .slide-description {
          font-size: 18px;
          line-height: 23px;
          margin-top: 9px;
        }
      }
    }

    .announcement {
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      justify-content: space-between;
      width: 764px;
      padding: 0;
      margin: 95px auto 0;

      &-list {
        min-height: 324px;
      }

      .head-banner {
        display: flex;
        width: 370px;
        height: 324px;
        border-radius: 23px;
        border: 2px solid #FFFFFF;

        &:hover {
          img {
            transform: scale(1.02);
          }
        }

        .head-img {
          width: 336px;
          height: 290px;
          overflow: hidden;
          border-radius: 10px;
        }

        img {
          width: 336px;
          height: 290px;
          border-radius: 10px;
          transition: transform .333s;
        }
      }

      .head-content {
        width: 336px;
        height: 72px;
        padding: 19px 11px;
        border-radius: 0px 0px 10px 10px;
        bottom: 17px;
      }

      .head-title {
        font-size: 17px;
        line-height: 25px;
      }

      .head-description {
        font-size: 11px;
        line-height: 17px;
      }

      &-title {
        width: 354px;
        padding: 10px 0;

        .title {
          font-size: 21px;
          line-height: 32px;
        }

        .more {
          font-size: 11px;
          line-height: 17px;
        }

        .arrow-icon {
          width: 6px;
          height: 6px;
          margin-left: 4px;
        }
      }

      &-item {
        width: 354px;
        height: 66px;
        padding: 20px 0 16px 21px;
        margin-top: 23px;
        border-radius: 23px;

        &:hover .item-icon {
          border: 1px solid #D779FF;
          background-size: 11px 6px;
          background-repeat: no-repeat;
          background-position: center;
        }
      }

      &-text {
        width: 250px;
        font-size: 12px;
        line-height: 19px;
      }

      &-date {
        font-size: 10px;
        line-height: 15px;
      }

      .item-icon {
        width: 11px;
        height: 6px;
        right: 16px;
        padding: 11px 9px 11px 8px;
        border: 1px solid #979797;
        border-radius: 50%;
        background-size: 11px 6px;
        background-position: center;
        background-color: #fff;
      }

    }

    .product {
      margin: 95px 0 0;

      .product-swiper-pagination {
        width: auto;
        background-color: #d1d1d1;
        padding: 4px 4px;
        border-radius: 8px;
        bottom: 20px !important;


        :deep(.swiper-pagination-bullet) {
          width: 6px;
          height: 6px;
          background: #fff;
          opacity: .8;
        }

        :deep(.swiper-pagination-bullet-active) {
          width: 15px;
          height: 6px;
          opacity: 1;
        }
      }

      .swiper-container {
        width: 100%;
        padding-top: 60px;
      }

      &-title {
        font-size: 21px;
        line-height: 32px;
      }

      .product-swiper {
        background: transparent;
        border: none;
        height: 400px;
      }

      .product-swiper-slide[data-swiper-slide-index="0"],
      .product-swiper-slide[data-swiper-slide-index="2"],
      .product-swiper-slide[data-swiper-slide-index="4"] {
        transform: translateY(-15px);
      }

      /* 原始索引为奇数的 slide 靠下 */
      .product-swiper-slide[data-swiper-slide-index="1"],
      .product-swiper-slide[data-swiper-slide-index="3"] {
        transform: translateY(15px);
      }

      .product-swiper-slide {
        width: 452px;
        height: 269px;
        padding: 17px;
        background: rgba(255, 255, 255, 0.5);
        border-radius: 23px;
        border: 2px solid #FFFFFF;
        backdrop-filter: blur(12px);
        -webkit-backdrop-filter: blur(12px);
        box-sizing: border-box;


        &:hover {
          .slide-image img {
            transform: scale(1.02);
          }
        }

        .slide-image {
          width: 100%;
          border-radius: 10px;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform .333s;
          }
        }

        .slide-content {
          width: calc(100% - 34px);
          border-radius: 0px 0px 10px 10px;
          padding: 19px 28px;
          box-sizing: border-box;
          height: 71px;
          margin-bottom: 17px;

          .slide-title {
            width: 100%;
            font-size: 17px;
            line-height: 25px;

          }

          .slide-description {
            font-size: 11px;
            line-height: 17px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }

    .download-container-pc {
      position: fixed;
      width: 105px;
      top: 70px;
      right: 12px;
      z-index: 99;
      background: rgba(255, 255, 255, 0.82);
      border-radius: 14px;
      border: 2px solid #D777FF;
      display: flex;
      align-items: center;
      flex-direction: column;
      padding: 10px 0;

      .qrcode {
        padding: 6px;
        width: 85px;
        height: 85px;
        box-sizing: border-box;
        background-color: #ffffff;
        border-radius: 7px;
        border: 1px solid #979797;
      }

      .sacn-code {
        font-weight: 900;
        font-size: 10px;
        color: #646464;
        line-height: 13px;
        text-align: center;
        margin-top: 5px;
      }

      .download::after {
        content: "";
        display: inline-block;
        width: 80px;
        border-bottom: 1px dashed #646464;
        position: absolute;
        bottom: 0;
        left: 4px;
      }

      .download {
        width: 87px;
        text-align: center;
        position: relative;
        padding-bottom: 10px;

        img {
          width: 87px;
          height: 27px;
          margin-top: 6px;
          object-fit: cover;
          cursor: pointer;
        }
      }

      .media {
        width: 77px;
        display: flex;
        justify-content: center;
        margin-top: 8px;

        &:has(> img:nth-child(2):last-child) img {
          margin: 0 3px;
        }

        img {
          width: 25px;
          height: 25px;
          cursor: pointer;
          border: 2px solid transparent;
          border-radius: 50%;
        }

        img:hover {
          border: 2px solid #d466ff;
        }
      }
    }

    .version-info-pc {
      padding: 0 7px;
      height: 21px;
      background: rgba(0, 0, 0, 0.15);
      border-radius: 23px;
      position: absolute;
      top: 0px;
      left: 96px;
      z-index: 11;
      display: flex;
      align-items: center;

      div {
        font-weight: bold;
        font-size: 8px;
        color: #FFFFFF;
        line-height: 13px;
        margin-right: 7px;
      }
    }

    .tips {
      width: 526px;
      height: 308px;

      &::before {
        background-image: url('../assets/images/home/tips-bg-pc.png');
      }

      &-close {
        width: 50px;
        height: 50px;
        right: 0;
        left: initial;
        top: 0;
        transform: translate(20px, -20px);
        z-index: 3;
        background: rgba(255, 255, 255, 0.5);
        border: 1px solid #FFFFFF;
        backdrop-filter: blur(10px);
        -webkit-backdrop-filter: blur(10px);
        background-image: url('../assets/images/home/close-icon.png');
        background-repeat: no-repeat;
        background-size: 20px 20px;
        background-position: 15px 15px;

        &:hover {
          transform: translate(20px, -20px) rotate(90deg);
        }
      }

      &-title {
        height: 50px;
        font-size: 17px;
        line-height: 50px;
      }

      &-content {
        width: 478px;
        height: 214px;
        margin-top: 20px;
        font-size: 9px;
        line-height: 16px;
      }
    }
  }
}

.vi {
  .version-info {
    bottom: 64px !important;

    div {
      color: #ffffff !important;
    }
  }
}

.ar {
  .download-container-pc {
    left: 0.12rem;
    right: initial;
  }

  .questionnaire {
    left: 29px;
    right: initial;
  }

  .home-tips {
    right: 0.29rem;
    left: initial !important;
  }

  .slide-content {
    direction: rtl;
    text-align: right;
  }

  .version-info {
    direction: rtl;
    text-align: right;
  }


  .announcement {
    direction: rtl;
    text-align: right;

    .arrow-icon {
      transform: scaleX(-1);
    }

    .item-icon {
      transform: scaleX(-1) translate(0, -50%);
      top: 50%;
      left: 0.46rem;
      right: initial;
    }
  }

  .tips {
    direction: rtl;
    text-align: right;
  }

  @media only screen and (min-width: 768px) {
    .home-tips {
      right: 0.24rem;
    }

    .questionnaire {
      left: 12px;
      right: initial;
    }

    .mod-home-swiper {
      .slide-content {
        padding: 0.28rem 0.96rem 0.22rem 0 !important;
      }
    }


    .version-info-pc {
      right: 0.96rem;
      left: initial;
    }

    .announcement {
      .announcement-item {
        padding: 0.2rem 0.21rem 0.16rem 0;
      }

      .item-icon {
        left: 0.16rem;
        right: initial;
      }
    }
  }
}
</style>
